// extracted by mini-css-extract-plugin
module.exports = {"afModuleTitleArena":"module-title_afModuleTitleArena__HsIn6","afModuleTitle":"module-title_afModuleTitle__3urD_","afModuleSubTitle":"module-title_afModuleSubTitle__2srVh"};